import { useState, useEffect } from "react";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SubMenu,
  SidebarHeader,
  SidebarFooter,
  SidebarContent,
} from "react-pro-sidebar";
import { Box, IconButton, InputAdornment, TextField, Typography, useTheme } from "@mui/material";
import { NavLink, useLocation } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { tokens } from "../../theme";
import Tooltip from "@mui/material/Tooltip";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ContactsOutlinedIcon from "@mui/icons-material/ContactsOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import SellOutlinedIcon from "@mui/icons-material/SellOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import LibraryBooksOutlinedIcon from "@mui/icons-material/LibraryBooksOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import SnippetFolderOutlinedIcon from "@mui/icons-material/SnippetFolderOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import DvrOutlinedIcon from "@mui/icons-material/DvrOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import FactoryOutlinedIcon from "@mui/icons-material/FactoryOutlined";
import RequestQuoteOutlinedIcon from "@mui/icons-material/RequestQuoteOutlined";
import BalanceOutlinedIcon from "@mui/icons-material/BalanceOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import ConnString from "../../ConnString.js";

const Connstring2 = ConnString.connstring;

const SidebarItem = ({ title, to, icon, selected, collapsed }) => {
  const theme = useTheme();
  const motif = theme.palette.motif;

  return (
    <MenuItem
      active={selected === to}
      icon={icon}
      style={{
        borderRadius: "14px",
        margin: "6px 8px",
        color: motif.text,
      }}
    >
      <NavLink
        to={to}
        end
        style={({ isActive }) => ({
          color: motif.text,
          textDecoration: "none",
          display: "flex",
          alignItems: "center",
          width: "100%",
          padding: "10px 14px",
          borderRadius: "12px",
          background: isActive ? motif.panelStrong : "transparent",
        })}
      >
        <Typography sx={{ fontSize: collapsed ? 0 : "0.95rem", fontWeight: 600 }}>
          {title}
        </Typography>
      </NavLink>
    </MenuItem>
  );
};

const mainLinks = [
  { id: "dashboard", title: "Dashboard", to: "dashboard", icon: <HomeOutlinedIcon /> },
  { id: "monitoring", title: "Monitoring", to: "monitoring", icon: <TrendingUpOutlinedIcon /> },
  { id: "monitoring", title: "Tasks", to: "TLMonitoringTasks", icon: <TrendingUpOutlinedIcon /> },
  { id: "monitoring", title: "Client Profile", to: "TlClientProfile", icon: <TrendingUpOutlinedIcon /> },

  { id: "retainer", title: "Retainers", to: "retainer", icon: <RequestQuoteOutlinedIcon /> },
  { id: "calendar", title: "Calendar", to: "calendar", icon: <CalendarTodayOutlinedIcon /> },
];

const salesLinks = [
  { id: "ACTCRP", title: "Cash Receipts", to: "TLCashReceipts", icon: <PaidOutlinedIcon /> },
  { id: "ACTSOA", title: "Sales On Account", to: "TLSalesOnAccount", icon: <ReceiptOutlinedIcon /> },
  { id: "ACTBST", title: "Billing Statement", to: "TLBillingStatement", icon: <ReceiptLongOutlinedIcon /> },
  { id: "ACTSRC", title: "Service Contracts", to: "TLServiceContracts", icon: <DescriptionOutlinedIcon /> },
];

const purchaseLinks = [
  { id: "ACTPVC", title: "Payment Voucher", to: "TLPaymentVoucher", icon: <PaymentsOutlinedIcon /> },
  { id: "ACTPOA", title: "Purchase On Account", to: "TLPurchaseOnAccount", icon: <ShoppingCartOutlinedIcon /> },
];

const genAcctLinks = [
  { id: "ACTJOV", title: "Journal Voucher", to: "TLJournalVoucher", icon: <MenuBookOutlinedIcon /> },
  { id: "ACTJVT", title: "JV Template", to: "TLJVTemplate", icon: <InsertDriveFileOutlinedIcon /> },
  { id: "ACTRJV", title: "Recurring JV", to: "TLRecurringJV", icon: <FactoryOutlinedIcon /> },
];

const inventoryInLinks = [
  { id: "PROCPO", title: "Purchase Order", to: "InventoryPurchaseOrder", icon: <ShoppingCartOutlinedIcon /> },
  { id: "PROREC", title: "Receiving PO", to: "InventoryReceivingPO", icon: <LocalShippingOutlinedIcon /> },
  { id: "INVREC", title: "Receiving", to: "InventoryReceiving", icon: <LocalShippingOutlinedIcon /> },
  { id: "INVSTI", title: "Stock IN", to: "InventoryTransferIn", icon: <DvrOutlinedIcon /> },
];

const inventoryOutLinks = [
  { id: "SLSSOD", title: "Sales Order", to: "InventorySalesOrder", icon: <ReceiptOutlinedIcon /> },
  { id: "INVDRS", title: "Delivery w/ SO", to: "InventoryDeliveryWithSO", icon: <LocalShippingOutlinedIcon /> },
  { id: "INVDRR", title: "Delivery", to: "InventoryDelivery", icon: <LocalShippingOutlinedIcon /> },
  { id: "INVSTO", title: "Stock OUT", to: "InventoryTransferOut", icon: <DvrOutlinedIcon /> },
];

const inventoryReportLinks = [
  { id: "INVRP1", title: "Remaining Inventory Report", to: "InventoryReports?report=remaining", icon: <AssessmentOutlinedIcon /> },
  { id: "INVRP2", title: "Stock Movement Report", to: "InventoryReports?report=movement", icon: <AssessmentOutlinedIcon /> },
  { id: "INVRP3", title: "Aging of Inventory Report", to: "InventoryReports?report=aging", icon: <AssessmentOutlinedIcon /> },
  { id: "INVRP4", title: "Critical Inventory Report", to: "InventoryReports?report=critical", icon: <AssessmentOutlinedIcon /> },
];
const ARReportLinks = [
  { id: "ARAG", title: "A/R Aging", to: "Report_ARAging", icon: <AssessmentOutlinedIcon /> },
];
const ISACAFSReportLinks = [
  { id: "ISACARPTIS", title: "Income Statement", to: "Report_ISACA_IS", icon: <AssessmentOutlinedIcon /> },
   { id: "ISACARPTBS", title: "Balance Sheet", to: "Report_ISACA_BS", icon: <AssessmentOutlinedIcon /> },
   { id: "ISACARPTTB", title: "Trial Balance", to: "Report_ISACA_TB", icon: <AssessmentOutlinedIcon /> },
];
const LiquidationReportLinks = [
  { id: "LIQREP", title: "Liquidation Report", to: "Report_LiquidationReport", icon: <AssessmentOutlinedIcon /> },
];

const AuditModuleLinks = [
  { id: "Audit", title: "Audit", to: "team", icon: <MenuBookOutlinedIcon /> },
  { id: "AUDMFC", title: "Company Profiles", to: "AUD_CompanyProfile", icon: <InsertDriveFileOutlinedIcon /> },
  { id: "AUDRPT", title: "Audit Report", to: "contacts", icon: <FactoryOutlinedIcon /> },
  { id: "AUDAFS", title: "Audited Financial Statements", to: "contacts", icon: <FactoryOutlinedIcon /> },
];

const InventoryModuleLinks = [
  { id: "INVTRYDB", title: "Inventory Dashboard", to: "InventoryDashboard", icon: <MenuBookOutlinedIcon /> },
  { id: "INVRPT", title: "Inventory Reports", to: "InventoryReports", icon: <InsertDriveFileOutlinedIcon /> },
   
];

const lendingLinks = [
  { id: "LendDashboard", title: "Dashboard for Lending", to: "LendingDashboard", icon: <HomeOutlinedIcon /> },
  { id: "MFBowers", title: "Borrowers", to: "BorrowerList", icon: <ContactsOutlinedIcon /> },
  { id: "LENLON", title: "Loans", to: "LoanList", icon: <AccountBalanceWalletOutlinedIcon /> },
];

const SidebarSubMenu = ({ title, to, icon, collapsed, forceOpen = false, children }) => {
  const theme = useTheme();
  const location = useLocation();
  const motif = theme.palette.motif;
  const submenuPalette = {
    defaultText: motif.text, activeText: motif.text, activeBg: motif.panelStrong,
    hoverBg: motif.panel, panelBg: motif.navPanel, border: motif.main,
    panelBorder: motif.border, arrowColor: motif.main,
    textSize: "0.80rem", itemTextSize: "0.80rem", fontWeight: 600,
  };

  const path = location.pathname || "";
  const lastSeg = path.split("/").filter(Boolean).pop() || "";
  const isActive = to && (path.includes(`/${to}`) || lastSeg === to);

  const titleContent = to ? (
    <NavLink
      to={to}
      end
      onClick={(event) => event.stopPropagation()}
      style={({ isActive: navIsActive }) => ({
        color: navIsActive || isActive ? submenuPalette.activeText : submenuPalette.defaultText,
        textDecoration: "none",
        display: "flex",
        alignItems: "center",
        width: "100%",
        padding: "8px 12px",
        borderRadius: "12px",
        background: navIsActive || isActive ? submenuPalette.activeBg : "transparent",
        border: navIsActive || isActive ? `1px solid ${submenuPalette.border}` : "1px solid transparent",
        transition: "background 160ms ease, color 160ms ease, border-color 160ms ease",
      })}
    >
      <Typography sx={{ fontSize: collapsed ? 0 : submenuPalette.textSize, fontWeight: submenuPalette.fontWeight }}>
        {title}
      </Typography>
    </NavLink>
  ) : (
    title
  );

  return (
    <SubMenu title={titleContent} icon={icon} defaultOpen={forceOpen} open={forceOpen ? true : undefined}>
      {children}
    </SubMenu>
  );
};

const Sidebar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const motif = theme.palette.motif;
  const location = useLocation();
  const selected = location.pathname.split("/").filter(Boolean).pop() || "dashboard";
  const [collapsed, setCollapsed] = useState(false);
  const [company, setCompany] = useState(
    sessionStorage.getItem("compName") || sessionStorage.getItem("selectedCompany") || "Business Journal"
  );
  const [userName, setUserName] = useState(
    sessionStorage.getItem("userFullName") || sessionStorage.getItem("userEmail") || "Admin"
  );
  const [compLogo, setCompLogo] = useState(sessionStorage.getItem("compLogo"));
  const [compID, setCompID] = useState(sessionStorage.getItem("compID"));
  const [userID, setUserID] = useState(sessionStorage.getItem("userID"));
  const [access, setAccess] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const fetchAccess = async () => {
      if (!compID || !userID) return;
      try {
        const res = await fetch(`${Connstring2}/api/user-access`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ companyID: compID, currentuserID: userID }),
        });
        const data = await res.json();
        if (data.success) {
          sessionStorage.setItem("userAccess", JSON.stringify(data.access));
          setAccess(data.access);
        }
      } catch (error) {
        console.error("Failed to fetch user access:", error);
      }
    };

    fetchAccess();
  }, [compID, userID]);

  const canAccess = (id) => access.includes(id);
  const matchesSearch = (item) => !search.trim() || item.title.toLowerCase().includes(search.trim().toLowerCase());
  const visibleLinks = (items) => items.filter((item) => canAccess(item.id) && matchesSearch(item));
  const visibleSales = visibleLinks(salesLinks);
  const visiblePurchases = visibleLinks(purchaseLinks);
  const visibleGenAcct = visibleLinks(genAcctLinks);
  const showSales = visibleSales.length > 0;
  const showPurchases = visiblePurchases.length > 0;
  const showGenAcct = visibleGenAcct.length > 0;
  const showTransactions = showSales || showPurchases || showGenAcct;
  
  
  const showARAging = ARReportLinks.some((item) => canAccess(item.id));
  
  const showLiquidationReport = LiquidationReportLinks.some((item) => canAccess(item.id));
 
  const showFSReportItems_Isaca = ISACAFSReportLinks.some((item) => canAccess(item.id));
  

  const showReports = showARAging || showLiquidationReport||showFSReportItems_Isaca;
  const showARReports  = showARAging||showLiquidationReport;
  const showFSReports_Isaca  = showFSReportItems_Isaca;

  

  const showAUCompProfile = AuditModuleLinks.some((item) => canAccess(item.id));
  const showAuditModule = showAUCompProfile; // You can add more conditions if there are more links in the AuditModuleLinks array
  
  const showInventoryDashboard = canAccess("INVTRYDB");
  const visibleInventoryIn = visibleLinks(inventoryInLinks);
  const visibleInventoryOut = visibleLinks(inventoryOutLinks);
  const visibleInventoryReports = visibleLinks(inventoryReportLinks);
  const showInventory = showInventoryDashboard || visibleInventoryIn.length > 0 || visibleInventoryOut.length > 0 || visibleInventoryReports.length > 0;
  const lendingGroupMatches = !search.trim() || "lending".includes(search.trim().toLowerCase());
  const permittedLendingLinks = lendingLinks.filter((item) => canAccess(item.id));
  const visibleLendingLinks = lendingGroupMatches
    ? permittedLendingLinks
    : permittedLendingLinks.filter(matchesSearch);
  const showLending = visibleLendingLinks.length > 0;
  
  return (
    <Box
      sx={{
        fontFamily: theme.typography.fontFamily,
        "& .pro-sidebar": {
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          width: collapsed ? "88px" : "280px",
          minWidth: collapsed ? "88px" : "280px",
          transition: "width 180ms ease",
        },
        "& .pro-sidebar-inner": {
          background: `${motif.nav} !important`,
          borderRadius: "24px",
          border: `1px solid ${motif.border}`,
          overflow: "hidden",
        },
        "& .pro-sidebar .pro-sidebar-header": {
          padding: "18px 18px",
        },
        "& .pro-sidebar .pro-sidebar-content": {
          paddingTop: "12px",
          overflowY: "auto",
        },
        "& .pro-inner-item": {
          padding: "10px 18px 10px 22px !important",
          borderRadius: "14px !important",
        },
        "& .pro-menu-item .MuiTypography-root": {
          fontFamily: `${theme.typography.fontFamily} !important`,
          fontSize: "0.95rem !important",
          fontWeight: "700 !important",
          letterSpacing: "0.01em",
        },
        "& .pro-menu-item > .pro-inner-item .pro-item-content": {
          fontFamily: `${theme.typography.fontFamily} !important`,
          fontSize: "0.95rem",
          fontWeight: 700,
          letterSpacing: "0.01em",
        },
        "& .pro-inner-item:hover": {
          color: `${motif.main} !important`,
        },
        "& .pro-menu-item.active": {
          backgroundColor: `${motif.panelStrong} !important`,
          color: `${motif.text} !important`,
        },
        "& .pro-icon-wrapper": {
          backgroundColor: "transparent !important",
          color: `${motif.main} !important`,
        },
        "& .pro-sub-menu > .pro-inner-list-item": {
          background: `${motif.navPanel} !important`,
          borderLeft: `1px solid ${motif.border}`,
          marginLeft: "12px",
          
          borderRadius: "0 0 16px 16px",
          overflow: "hidden",
          fontSize: "0.80rem",
        },
        "& .pro-sub-menu > .pro-inner-list-item .MuiTypography-root": {
          fontSize: "0.80rem !important",
          fontWeight: "600 !important",
        },
        "& .pro-sub-menu > .pro-inner-list-item .pro-item-content": {
          fontSize: "0.80rem !important",
          fontWeight: "600 !important",
        },
        "& .pro-sub-menu .pro-inner-list-item .pro-inner-item:hover": {
          background: `${motif.panel} !important`,
          color: `${motif.text} !important`,
        },
        "& .pro-sub-menu .pro-arrow-wrapper .pro-arrow": {
          borderColor: `${motif.main} !important`,
        },
        "& .pro-sub-menu.open > .pro-inner-item": {
          color: `${motif.text} !important`,
        },
      }}
    >
      <ProSidebar collapsed={collapsed}>
        <SidebarHeader>
          <Box display="flex" flexDirection="column" gap={2}>
            <Box display="flex" alignItems="center" justifyContent={collapsed ? "center" : "space-between"}>
              {!collapsed && (
                <Typography variant="h6" color={motif.text} fontWeight={700}>
                  Business Journal
                </Typography>
              )}
              <IconButton onClick={() => setCollapsed((prev) => !prev)} sx={{ color: motif.text }}>
                <MenuOutlinedIcon />
              </IconButton>
            </Box>

            {!collapsed && (
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                p={2}
                sx={{
                  backgroundColor: motif.navPanel,
                  border: `1px solid ${motif.border}`,
                  borderRadius: "18px",
                  boxShadow: theme.palette.mode === "dark" ? "0 18px 40px rgba(0,0,0,0.28)" : `0 18px 40px ${motif.border}55`,
                }}
              >
                {(() => {
                  const logoSrc = compLogo || `${process.env.PUBLIC_URL}/jaboylogo.png`;
                  return (
                    <Box sx={styles.logoWrapper}
                      component="img"
                      src={logoSrc}
                      alt="Company logo"
                      onError={(e) => {
                        // fallback to public path if compLogo is invalid
                        if (e && e.target) e.target.src = `${process.env.PUBLIC_URL}/jaboylogo.png`;
                      }}
                      //sx={{ width: 88, height: 88, borderRadius: "50%", objectFit: "cover" }}
                    />
                  );
                })()}
                {/* <Typography variant="subtitle1" color={colors.grey[100]} fontWeight={700} sx={{ mt: 1 }}>
                  {company}
                </Typography>
                <Typography variant="body2" color={colors.grey[400]}>
                  {userName}
                </Typography> */}
              </Box>
            )}
          </Box>
        </SidebarHeader>

        <SidebarContent>
          {!collapsed && (
            <Box px={2} pb={1}>
              <TextField
                fullWidth
                size="small"
                value={search}
                onChange={(event) => setSearch(event.target.value)}
                placeholder="Search modules..."
                inputProps={{ "aria-label": "Find a module" }}
                InputProps={{ startAdornment: <InputAdornment position="start"><SearchOutlinedIcon fontSize="small" /></InputAdornment> }}
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: 3, bgcolor: motif.paper, color: motif.text }, "& .MuiOutlinedInput-notchedOutline": { borderColor: motif.border } }}
              />
            </Box>
          )}
          <Menu iconShape="circle">
            {mainLinks.map((item) => 
            canAccess(item.id) && matchesSearch(item) ? (
              <Tooltip key={item.id} title={item.title} placement="right" disableHoverListener={!collapsed}>
                <Box>
                  <SidebarItem
                    title={item.title}
                    to={item.to}
                    icon={item.icon}
                    selected={selected}
                    collapsed={collapsed}
                  />
                </Box>
              </Tooltip>
            ): null
            )}

            {showTransactions && (
              <SidebarSubMenu title={collapsed ? "" : "Transactions"} icon={<StorefrontOutlinedIcon />} collapsed={collapsed} forceOpen={Boolean(search)}>
                {showSales && (
                  <SidebarSubMenu title={collapsed ? "" : "Sales"} icon={<SellOutlinedIcon />} collapsed={collapsed} forceOpen={Boolean(search)}>
                    {visibleSales.map((item) =>
                      (
                        <SidebarItem
                          key={item.id}
                          title={item.title}
                          to={item.to}
                          icon={item.icon}
                          selected={selected}
                          collapsed={collapsed}
                        />
                      )
                    )}
                  </SidebarSubMenu>
                )}
                {showPurchases && (
                  <SidebarSubMenu title={collapsed ? "" : "Purchases"} icon={<ShoppingCartOutlinedIcon />} collapsed={collapsed} forceOpen={Boolean(search)}>
                    {visiblePurchases.map((item) =>
                      (
                        <SidebarItem
                          key={item.id}
                          title={item.title}
                          to={item.to}
                          icon={item.icon}
                          selected={selected}
                          collapsed={collapsed}
                        />
                      )
                    )}
                  </SidebarSubMenu>
                )}
                {showGenAcct && (
                  <SidebarSubMenu title={collapsed ? "" : "Gen. Acctg"} icon={<LibraryBooksOutlinedIcon />} collapsed={collapsed} forceOpen={Boolean(search)}>
                    {visibleGenAcct.map((item) =>
                      (
                        <SidebarItem
                          key={item.id}
                          title={item.title}
                          to={item.to}
                          icon={item.icon}
                          selected={selected}
                          collapsed={collapsed}
                        />
                      )
                    )}
                  </SidebarSubMenu>
                )}
              </SidebarSubMenu>
            )}
            {showReports && (
              <SidebarSubMenu title={collapsed ? "" : "Reports"} to="Report_ARAging" icon={<StorefrontOutlinedIcon />} collapsed={collapsed}>      
                {showARAging && (
                  <SidebarSubMenu title={collapsed ? "" : "AR Reports"} to="Report_ARAging" icon={<SellOutlinedIcon />} collapsed={collapsed}>
                    {ARReportLinks.map((item) =>
                      canAccess(item.id) ? (
                        <SidebarItem
                          key={item.id}
                          title={item.title}
                          to={item.to}
                          icon={item.icon}
                          selected={selected}
                          collapsed={collapsed}
                        />
                      ) : null
                    )}
                     {LiquidationReportLinks.map((item) =>
                      canAccess(item.id) ? (
                        <SidebarItem
                          key={item.id}
                          title={item.title}
                          to={item.to}
                          icon={item.icon}
                          selected={selected}
                          collapsed={collapsed}
                        />
                      ) : null
                    )}
                  </SidebarSubMenu>
                )}
                {showFSReports_Isaca && (
                  <SidebarSubMenu title={collapsed ? "" : "Financial Reports"} to="Report_IS" icon={<StorefrontOutlinedIcon />} collapsed={collapsed}>
                    {ISACAFSReportLinks.map((item)=>
                     canAccess(item.id) ? (
                        <SidebarItem
                          key={item.id}
                          title={item.title}
                          to={item.to}
                          icon={item.icon}
                          selected={selected}
                          collapsed={collapsed}
                        />
                      ) : null

                    )}

                  </SidebarSubMenu>
                )

                }
                {/* {showLiquidationReport && (
                  <SidebarSubMenu title={collapsed ? "" : "Liquidation Report"} to="Report_LiquidationReport" icon={<SellOutlinedIcon />} collapsed={collapsed}>
                    {LiquidationReportLinks.map((item) =>
                      canAccess(item.id) ? (
                        <SidebarItem
                          key={item.id}
                          title={item.title}
                          to={item.to}
                          icon={item.icon}
                          selected={selected}
                          collapsed={collapsed}
                        />
                      ) : null
                    )}
                  </SidebarSubMenu> */}
                {/* )} */}
              </SidebarSubMenu>
            )}

     
            {showAuditModule && (
              <SidebarSubMenu title={collapsed ? "" : "Audit"} to="AUD_CompanyProfile" icon={<StorefrontOutlinedIcon />} collapsed={collapsed}>
                {showAUCompProfile && (
                  <SidebarSubMenu title={collapsed ? "" : "Company Profile"} to="AUD_CompanyProfile" icon={<SellOutlinedIcon />} collapsed={collapsed}>
                    {AuditModuleLinks.map((item) =>
                      canAccess(item.id) ? (
                        <SidebarItem
                          key={item.id}
                          title={item.title}
                          to={item.to}
                          icon={item.icon}
                          selected={selected}
                          collapsed={collapsed}
                        />
                      ) : null
                    )}
                  </SidebarSubMenu>
                )}
              </SidebarSubMenu>
            )}


            {showInventory && (
              <SidebarSubMenu title={collapsed ? "" : "Inventory"} icon={<StorefrontOutlinedIcon />} collapsed={collapsed} forceOpen={Boolean(search)}>
                {showInventoryDashboard && matchesSearch({ title: "Dashboard" }) && <SidebarItem title="Dashboard" to="InventoryDashboard" icon={<MenuBookOutlinedIcon />} selected={selected} collapsed={collapsed} />}
                {visibleInventoryIn.length > 0 && (
                  <SidebarSubMenu title={collapsed ? "" : "Inventory IN"} icon={<ShoppingCartOutlinedIcon />} collapsed={collapsed} forceOpen={Boolean(search)}>
                    {visibleInventoryIn.map((item) => <SidebarItem key={item.id} {...item} selected={selected} collapsed={collapsed} />)}
                  </SidebarSubMenu>
                )}
                {visibleInventoryOut.length > 0 && (
                  <SidebarSubMenu title={collapsed ? "" : "Inventory Out"} icon={<LocalShippingOutlinedIcon />} collapsed={collapsed} forceOpen={Boolean(search)}>
                    {visibleInventoryOut.map((item) => <SidebarItem key={item.id} {...item} selected={selected} collapsed={collapsed} />)}
                  </SidebarSubMenu>
                )}
                {visibleInventoryReports.length > 0 && (
                  <SidebarSubMenu title={collapsed ? "" : "Inventory Reports"} icon={<AssessmentOutlinedIcon />} collapsed={collapsed} forceOpen={Boolean(search)}>
                    {visibleInventoryReports.map((item) => <SidebarItem key={item.id} {...item} selected={selected} collapsed={collapsed} />)}
                  </SidebarSubMenu>
                )}
              </SidebarSubMenu>
            )}

            {showLending && (
              <SidebarSubMenu
                title={collapsed ? "" : "Lending"}
                icon={<AccountBalanceWalletOutlinedIcon />}
                collapsed={collapsed}
                forceOpen={Boolean(search)}
              >
                {visibleLendingLinks.map((item) => (
                  <SidebarItem
                    key={item.id}
                    {...item}
                    selected={selected}
                    collapsed={collapsed}
                  />
                ))}
              </SidebarSubMenu>
            )}

            {/* <SidebarSubMenu title={collapsed ? "" : "Books of Accounts"} to="team" icon={<LibraryBooksOutlinedIcon />} collapsed={collapsed}>
              <SidebarItem title="Cash Receipts Journal" to="team" icon={<PaidOutlinedIcon />} selected={selected} collapsed={collapsed} />
              <SidebarItem title="Cash Disbursement Journal" to="contacts" icon={<PaymentsOutlinedIcon />} selected={selected} collapsed={collapsed} />
              <SidebarItem title="Sales Journal" to="invoices" icon={<SellOutlinedIcon />} selected={selected} collapsed={collapsed} />
              <SidebarItem title="Purchase Journal" to="invoices" icon={<ShoppingCartOutlinedIcon />} selected={selected} collapsed={collapsed} />
            </SidebarSubMenu>

            <SidebarSubMenu title={collapsed ? "" : "BIR Forms"} to="team" icon={<AssignmentOutlinedIcon />} collapsed={collapsed}>
              <SidebarItem title="VAT Returns" to="team" icon={<InsertDriveFileOutlinedIcon />} selected={selected} collapsed={collapsed} />
              <SidebarItem title="WTax Expanded Returns" to="team" icon={<BalanceOutlinedIcon />} selected={selected} collapsed={collapsed} />
            </SidebarSubMenu>

            <SidebarSubMenu title={collapsed ? "" : "Financial Reports"} to="invoices" icon={<AssessmentOutlinedIcon />} collapsed={collapsed}>
              <SidebarItem title="Worksheet" to="invoices" icon={<DescriptionOutlinedIcon />} selected={selected} collapsed={collapsed} />
              <SidebarItem title="Trial Balance" to="invoices" icon={<BalanceOutlinedIcon />} selected={selected} collapsed={collapsed} />
              <SidebarItem title="Income Statement" to="invoices" icon={<TrendingUpOutlinedIcon />} selected={selected} collapsed={collapsed} />
            </SidebarSubMenu> */}
          </Menu>
        </SidebarContent>

        <SidebarFooter>
          <Box p={2} display="flex" justifyContent={collapsed ? "center" : "space-between"} alignItems="center">
            <Typography color={colors.grey[500]} fontSize="0.8rem">
              © 2025 Business Journal
            </Typography>
          </Box>
        </SidebarFooter>
      </ProSidebar>
    </Box>
  );
};



const styles = {
  sidebarSubMenu: {
    defaultText: 'rgba(3, 51, 114, 0.88)',
    activeText: '#01050a',
    activeBg: 'linear-gradient(135deg, rgba(14,165,233,0.30), rgba(6,182,212,0.22))',
    hoverBg: 'rgba(14,165,233,0.14)',
    panelBg: 'rgba(208, 211, 220, 0.42)',
    border: 'rgba(56,189,248,0.16)',
    panelBorder: 'rgba(216, 223, 225, 0.14)',
    arrowColor: 'rgba(0, 7, 10, 0.85)',
    textSize: '0.80rem',
    fontWeight: 600,
  },
  logoWrapper: {
    display: 'block',
    width: '100%',
    maxWidth: '160px',
    height: '50px',
    margin: '0 auto',
    objectFit: 'contain',
    objectPosition: 'center',
    borderRadius: '10%',
   
 
    //backgroundColor: '#f9fbff', // Optional: Add a background color if needed
    //boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional: Add a subtle shadow for better visibility

     //sx={{ width: 88, height: 88, borderRadius: "50%", objectFit: "cover" }}
  },
};

export default Sidebar;
